export interface HideCustomerCommentResponse {
  messageCode: string;
  success: boolean;
}

export const EMPTY_HIDE_CUSTOMER_COMMENT_RESPONSE: HideCustomerCommentResponse =
  {
    messageCode: '',
    success: false,
  };
